import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, CONTACT_INFO } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export const Footer = () => (
    <footer className="border-t border-white/10 bg-sf-black" data-testid="site-footer">
        <div className="sf-container py-20 md:py-28">
            <Reveal>
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 pb-16 border-b border-white/10">
                    <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tight text-white max-w-3xl">
                        Let&apos;s Build the <span className="text-sf-green">Future</span> Together.
                    </h2>
                    <Link to="/contact" data-testid="footer-cta" className="sf-btn-primary shrink-0">
                        Start an Enquiry <ArrowUpRight size={16} />
                    </Link>
                </div>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pt-16">
                <div>
                    <img src="/logo.jpg" alt="Super Finishers" className="h-14 w-14 object-cover mb-6" />
                    <p className="font-display font-extrabold text-white tracking-wide">SUPER FINISHERS</p>
                    <p className="font-mono text-[10px] tracking-[0.35em] text-sf-green mt-2 uppercase">Success Through Quality</p>
                    <p className="text-sf-silver text-sm leading-relaxed mt-6 max-w-xs">
                        Precision tubular components, automotive components and cycle parts — engineered and manufactured in India since 2007.
                    </p>
                </div>
                <div>
                    <p className="sf-overline mb-6">Navigate</p>
                    <ul className="space-y-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <Link
                                    to={link.path}
                                    data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                    className="text-white/60 text-sm hover:text-sf-green transition-colors duration-300"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="sf-overline mb-6">Contact</p>
                    <ul className="space-y-3 text-sm text-white/60">
                        <li data-testid="footer-address">{CONTACT_INFO.address}</li>
                        <li data-testid="footer-email">{CONTACT_INFO.email}</li>
                    </ul>
                    <p className="mt-8 inline-block border border-sf-green/40 text-sf-green font-mono text-[10px] tracking-[0.25em] uppercase px-4 py-2">
                        ISO 9001:2015 Certified
                    </p>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-between gap-4 pt-16 mt-16 border-t border-white/10">
                <p className="text-white/40 text-xs font-mono tracking-wider" data-testid="footer-copyright">
                    © {new Date().getFullYear()} SUPER FINISHERS. ALL RIGHTS RESERVED.
                </p>
                <p className="text-white/40 text-xs font-mono tracking-wider">EST. 2007 — FARIDABAD, INDIA</p>
            </div>
        </div>
    </footer>
);
